import {
  calculateColumnWidth,
  mapColumnTypes,
  TYPES,
} from "@/react/components/table/columns";
import { getColumnDef } from "@/react/schema/schemaFields";
import schema, {
  thirdPartyMap,
} from "@/react/features/vcc/sms-channels/schema";
import { PhoneNumberCell } from "@/react/features/vcc/sms-channels/PhoneNumberCell";
import { CountrySelectorCell } from "@/react/features/vcc/sms-channels/CountrySelectorCell";
import { WavecellStringCell } from "@/react/features/vcc/sms-channels/WavecellStringCell";

const columnDefinition = () =>
  calculateColumnWidth(
    [
      { ...getColumnDef(schema.fields.channelId, "ID"), size: 70 },
      {
        ...getColumnDef(schema.fields.thirdParty, "Third Party"),
        type: TYPES.SELECT,
        options: {
          [thirdPartyMap.TWILIO]: "Twilio",
          [thirdPartyMap.INTQ_REST]: "Inteliquent",
          [thirdPartyMap.WAVECELL]: "CPaaS",
        },
        editable: true,
      },
      {
        ...getColumnDef(schema.fields.countryCode, "Country"),
        editableCell: CountrySelectorCell,
        editable: true,
      },
      {
        ...getColumnDef(schema.fields.phoneNumber, "Phone Number"),
        columnSetter: false,
        editableCell: PhoneNumberCell,
        editable: true,
      },
      {
        ...getColumnDef(
          schema.fields.wavecellSubAccountId,
          "CPaaS Sub-Account ID"
        ),
        editableCell: WavecellStringCell,
        editable: true,
      },
      {
        ...getColumnDef(schema.fields.wavecellApiKey, "CPaaS API Key"),
        editableCell: WavecellStringCell,
        editable: true,
      },
      {
        ...getColumnDef(schema.fields.status, "Status"),
      },
      {
        ...getColumnDef(schema.fields.subscriptionId, "Subscription ID"),
        defaultHidden: true,
      },
      {
        ...getColumnDef(schema.fields.scriptId, "Script ID"),
        defaultHidden: true,
      },
      {
        ...getColumnDef(schema.fields.queueId, "Queue ID"),
        defaultHidden: true,
      },
      { ...getColumnDef(schema.fields.didId, "DID ID"), defaultHidden: true },
    ].map(mapColumnTypes)
  );

export default columnDefinition;
